import * as types from './action-types';

export function searchAddressSuccess(suggestedAddresses) {
    return { type: types.SEARCH_ADDRESS_SUCCESS, suggestedAddresses };
}

export function searchAddressError(searchAddressMessages) {
    return { type: types.SEARCH_ADDRESS_ERROR, searchAddressMessages };
}

export function retrieveAddressSuccess(addressData) {
    return { type: types.RETRIEVE_ADDRESS_SUCCESS, addressData };
}

export function retrieveAddressError(retrieveAddressMessages) {
    return { type: types.RETRIEVE_ADDRESS_ERROR, retrieveAddressMessages };
}

export function resetRetrievedUserAddress() {
    return { type: types.RESET_RETRIEVE_USER_ADDRESS };
}

export function resetUpgradeAccountFormState() {
    return { type: types.RESET_UPGRADE_ACCOUNT_FORM };
}

